var option_default = {
  "option": "fnAQS",
  "user_choice": "ToDA9",
  "check": "_76xoU",
  "image": "gqBdU",
  "input": "fLul2",
  "title": "Lyd84",
  "centered": "_9krdL",
  "with_result": "A9ggD",
  "list": "VEQBb",
  "with_image": "KVpcc",
  "progress": "_6xUUC",
  "progress_value": "KOtEi",
  "label": "iGVAg",
  "cta": "d3aym",
  "adornment_icon": "YXGmc",
  "remove": "OJTGK",
  "removeButton": "HBWFV",
  "removeButtonIcon": "UbrJY",
  "overlay": "LtwNJ",
  "shown": "rCsx2",
  "dark": "W1bGo",
  "spinner": "mg9aK",
  "spin": "SOuvY"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
